import React from "react";
import { Button } from "antd";
import { openSecureDocumentById, getDocumentFileId } from "../../../utils/document";

function ViewDocumentLink({ file, label = "View uploaded document" }) {
  const fileId = file && getDocumentFileId(file);
  if (!fileId) return null;

  return (
    <Button
      type="link"
      size="small"
      style={{ paddingLeft: 0, marginTop: 4,color:"#027d79" }}
      onClick={() =>
        openSecureDocumentById({
          fileId,
          fileName: file?.file_name || file?.name || label,
          onError: (msg) => console.error(msg),
        })
      }
    >
      {label}
    </Button>
  );
}

export default ViewDocumentLink;
